// extracted by mini-css-extract-plugin
export default {"container":"cookieBannerPanel_container"};